export enum ExtraType {
  /** 数字人 */
  DIGITAL_MAN = 10,
}
